import type { QueryFunctionContext } from '@tanstack/react-query';
import { JobsAdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.backupFilesByJob>>;

export const createFetchJobBackupFilesQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ jobId }], signal }: TParams) =>
    (await call(() => cancelOnSignal(JobsAdminService.adminGetJobBackupFiles({ jobId }), signal))) ?? [];
